import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartCategoryAxisTitle,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesLabels,
  ChartTitle,
} from "@progress/kendo-react-charts";
import {
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardTitle,
} from "@progress/kendo-react-layout";

export const DonutCharts = ({
  type = "donut",
  title = "",
  data = [],
  currentTheme,
  legendPosition = "bottom",
  labelContent = (e) => e.value + " " + e.category,
  widthChart = "auto",
}) => {
  return (
    <Chart className="custom-donut-chart" style={{ width: widthChart }}>
      <ChartTitle
        text={title}
        color="#000"
        font="bold 16px Arial"
      ></ChartTitle>
      <ChartSeries>
        <ChartSeriesItem
          type={type}
          data={data}
          categoryField="category"
          field="value"
          colorField="color"
        >
          <ChartSeriesLabels
            color={currentTheme.primary}
            background="none"
            content={labelContent}
            position="outsideEnd"
          ></ChartSeriesLabels>
        </ChartSeriesItem>
      </ChartSeries>
      <ChartLegend position={legendPosition} color={currentTheme.primary} />
    </Chart>
  );
};

export const ChartContainer = ({
  title,
  categories,
  categoryAxisTitle,
  series,
  type = "bar",
}) => (
  <Chart>
    <ChartTitle text={title} color="#000" font="bold 16px Arial" />
    <ChartCategoryAxis>
      <ChartCategoryAxisItem categories={categories}>
        <ChartCategoryAxisTitle text={categoryAxisTitle} />
      </ChartCategoryAxisItem>
    </ChartCategoryAxis>
    <ChartSeries>
      {series.map((data, index) => (
        <ChartSeriesItem
          key={index}
          type={type}
          gap={2}
          spacing={0.25}
          data={data}
        />
      ))}
    </ChartSeries>
  </Chart>
);

export const CardChart = ({
  cardClass = "",
  title = "",
  subtitle = "",
  children = "",
  style = "",
}) => {
  return (
    <div style={style} className={cardClass}>
      <Card>
        <CardHeader>
          {title && <CardTitle>{title}</CardTitle>}
          {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
        </CardHeader>
        {children && <CardBody>{children}</CardBody>}
      </Card>
    </div>
  );
};
